import auth from "@/middleware/auth";

export const routes = [
  {
    path: "/compliance/aml/siprelad/operations",
    name: "Contratos Siprelad",
    component: () => import("../views/admin/aml/siprelad/siprelad-operations.vue"),
    meta: {
      middleware: [auth],
      rule: "isBackoffice",
    },
  },
  {
    path: "/support-areas/internal-control/condusef/redeco/complaint-reports",
    name: "Redeco - Reporte de Quejas",
    component: () => import("../views/support-areas/internal-control/condusef/redeco/complaint-reports"),
    meta: {
      middleware: [auth],
      rule: "isBackoffice",
    },
  },
  {
    path: "/support-areas/internal-control/condusef/reune",
    name: "Reune",
    component: () => import("../views/support-areas/internal-control/condusef/reune/index"),
    meta: {
      middleware: [auth],
      rule: "isBackoffice",
    },
  },
  {
    path: "/support-areas/internal-control/condusef/reune/general-requests",
    name: "Reune - Consultas Generales",
    component: () => import("../views/support-areas/internal-control/condusef/reune/general-requests.vue"),
    meta: {
      middleware: [auth],
      rule: "isBackoffice",
    },
  },
  {
    path: "/support-areas/internal-control/condusef/reune/general-claims",
    name: "Reune - Reclamaciones",
    component: () => import("../views/support-areas/internal-control/condusef/reune/general-claims.vue"),
    meta: {
      middleware: [auth],
      rule: "isBackoffice",
    },
  },
  {
    path: "/support-areas/internal-control/condusef/reune/general-clarifications",
    name: "Reune - Aclaraciones",
    component: () => import("../views/support-areas/internal-control/condusef/reune/general-clarifications.vue"),
    meta: {
      middleware: [auth],
      rule: "isBackoffice",
    },
  },
  {
    path: '/business/treasury/dispersions/conciliation-stp',
    name: 'Conciliación STP',
    component: () => import('../views/business/treasury/dispersions/conciliation-stp.vue'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/bo/:id/:pathName',
    name: 'Menú',
    component: () => import('@views/menu.vue'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/rug',
    name: 'RUG',
    component: () => import('../views/admin/rug/index'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice'
    }
  },
  {
    path: '/fraud-prevention',
    component: () => import('../views/admin/FraudPrevention/FraudPreventionView'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice'
    },
    children: [
      {
        path: '',
        name: 'Prevención de Fraude - Dashboard',
        component: () => import('../views/admin/FraudPrevention/FraudPreventionMenuView'),
        meta: {
          middleware: [auth],
          rule: 'isBackoffice'
        },
      },
      {
        path: 'black-list',
        name: 'Prevención de Fraude - Lista negra',
        component: () => import('../views/admin/FraudPrevention/BlackList/BlackListView'),
        meta: {
          middleware: [auth],
          rule: 'isBackoffice'
        },
      }
    ]
  },

  {
    path: '/retention/dashboard',
    name: 'Panel de retenciones V2',
    component: () => import('../views/admin/retention-dashboard/v2/MonthlyRetentionDashboard'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice'
    }
  },
  {
    path: '/loan-payments/pid/:id',
    name: 'Pagos de crédito',
    component: () => import('../views/admin/loan-payment/loan-payment-view'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice'
    }
  },
  {
    path: '/risk-model/admin',
    name: "Modelos de Riesgo - Admin",
    component: () => import('../views/admin/RiskModel/Admin/Index'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice'
    }
  },
  {
    path: '/risk-model',
    name: "Modelos de Riesgo - Home",
    component: () => import('../views/admin/RiskModel/Index.vue'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice'
    }
  },
  {
    path: '/risk-model/requests',
    name: "Modelos de Riesgo - Solicitudes",
    component: () => import('../views/admin/RiskModel/Dashboard/ProjectInRevisionList'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice'
    }
  },
  {
    path: '/risk-model/config/cdc-connection',
    name: "Modelos de Riesgo - Configuración de conexión CDC",
    component: () => import('../views/admin/RiskModel/Configuration/CdcConnection'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice'
    }
  },
  {
    path: '/risk-model/:id',
    name: "Modelos de Riesgo - Solicitud",
    component: () => import('../views/admin/RiskModel/Dashboard/Index'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice'
    }
  },
  {
    path: '/risk-model/admin/:id/editor',
    name: "Modelos de Riesgo - Editor de versiones",
    component: () => import('../views/admin/RiskModel/Admin/RiskModelEditor/RiskModelEditor.vue'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice'
    }
  },
  {
    path: '/risk-model/admin/catalogs',
    name: "Modelos de Riesgo - Catálogo",
    component: () => import('../views/admin/RiskModel/Admin/RiskModelCatalogs.vue'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice'
    }
  },
  {
    path: '/risk-model/admin/catalog/:id',
    name: "Modelos de Riesgo - Editar catálogo",
    component: () => import('../views/admin/RiskModel/Admin/RiskModelCatalogEditor.vue'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice'
    }
  },
  {
    path: '/risk-model/admin/:riskModelId/versions',
    name: "Modelos de Riesgo - Versión de modelo",
    component: () => import('../views/admin/RiskModel/Admin/Versions'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice'
    }
  },
  {
    path: '/risk-model/playground',
    name: "Playground",
    component: () => import('../views/admin/RiskModel/Admin/Playground'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice'
    }
  },
  {
    path: '/risk-model/admin/:riskModelId/version/:versionId/groups',
    name: "Modelos de Riesgo - Grupos",
    component: () => import('../views/admin/RiskModel/Admin/Groups'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice'
    }
  },
  {
    path: '/risk-model/admin/:riskModelId/groups/:groupId/rules',
    name: "Modelos de Riesgo - Reglas",
    component: () => import('../views/admin/RiskModel/Admin/Rules'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice'
    }
  },
  {
    path: '/risk-model/approve-risk-model',
    name: "Modelos de Riesgo - Aprobación",
    component: () => import('../views/admin/RiskModel/Dashboard/RiskModel/ApproveForm/ApproveModelRiskForm'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice'
    }
  },
  {
    path: '/risk-model/catalog/:id/items',
    name: "Modelos de Riesgo - Catálogo items",
    component: () => import('../views/admin/RiskModel/Catalogs/Index'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice'
    }
  },
  {
    path: '/risk-model/catalogs',
    name: "Modelos de Riesgo - Catálogos",
    component: () => import('../views/admin/RiskModel/Catalogs/CatalogTypes'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice'
    }
  },
  {
    path: '/risk-model/expediente/:id',
    name: "Expediente de la solicitud",
    props: true,
    component: () => import('../views/admin/RiskModel/LoanRequest/LoanRequestPage.vue'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice'
    }
  },
  {
    path: '/investor-analysis-report',
    name: 'Análisis de Inversionistas',
    component: () => import('../views/admin/InvestorAnalysisReport'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice'
    }
  },
  {
    path: '/promotion/create-bonus',
    name: 'Gestión de bonos',
    component: () => import('../views/admin/Promotions/CreateNewBonus'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice'
    }
  },
  {
    path: '/stp-account/create/ppid/:id',
    name: 'Crear cuenta STP PF',
    component: () => import('../views/admin/StpAccount/Person/Index'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice'
    }
  },
  {
    path: '/payment-processor-trx/failed',
    name: 'Operaciones fallidas',
    component: () => import('../views/admin/ChargeFailed/Index'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice'
    }
  },
  {
    path: '/accounting/third-party-balance-report',
    name: 'Reporte balances a terceros',
    component: () => import('../views/admin/accounting/ThirdPartyBalanceReport'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/direct-billing',
    name: 'Domiciliación solicitantes',
    component: () => import('../views/admin/DirectBilling/PreviewResponseFile'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/direct-billing/investor',
    name: 'Domiciliación inversionistas',
    component: () => import('../views/admin/DirectBilling/InvestorPreviewResponseFile'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/dev-tools',
    name: 'Dev Tools',
    component: () => import('../views/devTools/index'),
    children: [
      {
        path: 'solar-credit-verification',
        component: () => import("../views/devTools/SolarCreditVerification"),
        meta: {
          middleware: [auth],
          rule: 'isBackoffice',
        }
      }
    ],
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/api-doc',
    name: 'Api Documentation',
    component: () => import('../views/apiDoc'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: "/configuration/develop/tools/neighborhood-updater",
    name: "Actualizar colonias",
    component: () => import("../views/configuration/develop/tools/neighborhood-updater.vue"),
    meta: {
      middleware: [auth],
      rule: "isBackoffice",
    },
  },
  {
    path: '/develop',
    name: 'develop',
    component: () => import('../views/admin/dev'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/develop/config-cache',
    name: 'Config Cache',
    component: () => import('../views/admin/dev/ConfigCache.vue'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/document-manager/check-buckets',
    name: 'Check Buckets',
    component: () => import('../views/admin/dev/DocumentManagerReport.vue'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/v2',
    name: 'Servicios Operativos',
    component: () => import('../views/admin/OPSDashboard'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/business/origination/dashboards/origination-metrics',
    name: 'Métricas de originación',
    component: () => import('../views/business/origination/dashboards/origination-metrics.vue'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/',
    name: 'Inicio',
    component: () => import('../views/dashboards/home.vue'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/funnel',
    name: 'Funnel',
    component: () => import('../views/admin/Funnel'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/transactions-monitor',
    name: 'Monitor de transacciones',
    component: () => import('../views/admin/analytics/TransactionsMonitor'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/tokens',
    name: 'Desarrolladores',
    component: () => import('../views/admin/Developers'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/risk-factors',
    name: 'Factores de riesgos',
    component: () => import('../views/admin/risk-factors/RiskFactor'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },

  {
    path: '/clients-control',
    name: 'Control de Clientes',
    component: () => import('../views/admin/ClientsControl'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/steal-loss-reports',
    name: 'Reportes Robo o Extravío',
    component: () => import('../views/admin/StealLossReports'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/logs-dashboard',
    name: 'Dashboard Logs',
    component: () => import('../views/admin/logs/LogsDashboard'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/users-profile-integration',
    name: 'Integración perfiles',
    component: () => import('../views/admin/internal-control/UsersProfileIntegration'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/user-record-creator',
    name: 'Creador de expedientes',
    component: () => import('../views/admin/internal-control/UserRecordCreator'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/curp-verification',
    name: 'Verificación CURP',
    component: () => import('../views/admin/CURPVerification'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/business/treasury/tools/balances',
    name: 'Saldo de cuentas',
    component: () => import('../views/business/treasury/tools/balances'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/admon/import-bonus',
    name: 'Importar bonos',
    component: () => import('../views/admin/import-bonus'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    },
    props: {
      seccion: 2
    }
  },
  {
    path: '/clients/:id',
    name: 'Cliente',
    component: () => import('../views/admin/Client'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    },
    props: {
      storage: process.env.VUE_APP_STORAGE_URL
    }
  },
  {
    path: '/dashboards',
    exact: true,
    name: 'Dashboard',
    component: () => import('../views/admin/Dashboard'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/cobranza',
    name: 'Cobranza',
    component: () => import('../views/admin/cobranza/DashboardCollectionV2'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/cobranza/:id',
    name: 'CobranzaProyecto',
    component: () => import('../views/admin/cobranza/ProjectView'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/reporte-domiciliacion',
    name: 'ReporteDomiciliacion',
    component: () => import('../views/admin/cobranza/DirectBillingReport'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/debt_collectors/assign',
    name: 'DebtCollectorsAssign',
    component: () => import('../views/admin/cobranza/DebtCollectorsAssign'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  // TODO-DELETE-IA 20/02/2024 se obtendra por metabase
  // {
  //     path: '/reporte-deteccion',
  //     name: 'ReporteDeteccion',
  //     component: () => import('../views/admin/cobranza/DetectionReport'),
  //     meta: {
  //         middleware: [auth],
  //         rule: 'isBackoffice',
  //     }
  // },
  {
    path: '/suppliers-due-portfolio',
    name: 'CarteraVencidaInstaladores',
    component: () => import('../views/admin/cobranza/DuePortfolioBySupplier'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/admon/reembolsos',
    name: 'Reembolsos',
    component: () => import('../views/admin/admon/refund'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  // TODO-DELETE-IA 20/02/2024 se obtendra por metabase
  // {
  //     path: '/cartera-estatus',
  //     name: 'Cartera Por Estatus',
  //     component: () => import('../views/admin/cobranza/CarteraEstatus'),
  //     meta: {
  //         middleware: [auth],
  //         rule: 'isBackoffice',
  //     }
  // },
  {
    path: '/sic_reports',
    name: 'Reportes SIC',
    component: () => import('../views/admin/cobranza/SIC'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/investors',
    name: 'Inversionistas',
    component: () => import('../views/admin/Investors'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/investor/:id',
    component: () => import('../views/admin/InvestorDetails'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    },
    children: [
      {
        path: '',
        name: 'investorMain',
        component: () => import('@/views/admin/investor/InvestorProfileRootPage'),
        meta: {
          middleware: [auth],
          rule: 'isBackoffice',
        }
      },
      {
        path: ':tab',
        name: 'investorTabs',
        props: true,
        component: () => import('@/views/admin/investor/InvestorProfileRootPage'),
        meta: {
          middleware: [auth],
          rule: 'isBackoffice',
        }
      },
      {
        path: 'info/perfil',
        name: 'perfilInversionistaAbout',
        component: () => import('@/views/admin/investor/profile/AboutYou'),
        meta: {
          middleware: [auth],
          rule: 'isBackoffice',
          breadcrumb: {name: 'Perfil', parent: 'main'}
        }
      },
      {
        path: 'info/contacto',
        name: 'perfilInversionistaContact',
        component: () => import('@/views/admin/investor/profile/InvestorContact'),
        meta: {
          middleware: [auth],
          rule: 'isBackoffice',
          breadcrumb: {name: 'Contacto', parent: 'main'}
        }
      },
      {
        path: 'info/banco',
        name: 'perfilInversionistaBank',
        component: () => import('@/views/admin/investor/profile/InvestorBank'),
        meta: {
          middleware: [auth],
          rule: 'isBackoffice',
          breadcrumb: {name: 'Banco', parent: 'main'}
        }
      },
      {
        path: 'info/beneficiarios',
        name: 'perfilInversionistaBeneficiaries',
        component: () => import('@/views/admin/investor/profile/InvestorBeneficiaries'),
        meta: {
          middleware: [auth],
          rule: 'isBackoffice',
          breadcrumb: {name: 'Beneficiarios', parent: 'main'}
        }
      },
      {
        path: 'info/perfil-fiscal',
        name: 'investorTaxProfile',
        component: () => import('@/views/admin/investor/profile/InvestorTaxProfile'),
        meta: {
          middleware: [auth],
          rule: 'isBackoffice',
          breadcrumb: {name: 'Perfil fiscal', parent: 'main'}
        }
      },
      {
        path: 'plan/criterios-inversion',
        name: 'inversionistaCriteriosInversion',
        component: () => import('@/views/admin/investor/plans/InvestmentsPrefs'),
        meta: {
          middleware: [auth],
          rule: 'isBackoffice',
          breadcrumb: {name: 'Criterios de inversión', parent: 'plan'}
        }
      },
    ]
  },
  {
    path: '/suppliers',
    name: 'Instaladores',
    component: () => import('../views/admin/suppliers/suppliers.vue'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    },
  },
  {
    path: '/suppliers/reporte-anual',
    name: 'Actividad de proveedores',
    component: () => import('../views/admin/suppliers/ProjectStatsDashboard.vue'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    },
  },
  {
    path: '/suppliers/payments',
    name: 'Pagos a proveedores',
    component: () => import('../views/admin/treasury/withdrawals-supplier-module'),
    props: {
      variant: 'supplierModule'
    },
    meta: {
      middleware: [auth],
      rule: 'isBackoffice'
    }
  },
  {
    path: '/suppliers/notVerified',
    name: 'Instaladores por verificar',
    component: () => import('../views/admin/suppliers/SuppliersNotVerified.vue'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    },
  },
  {
    path: '/technologies/notVerified',
    name: 'Tecnologías por verificar',
    component: () => import('../views/admin/suppliers/TecnologiesNotVerified.vue'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    },
  },
  {
    path: '/bankAccounts/notVerified',
    name: 'Verificación de cuentas bancarias',
    component: () => import('../views/admin/suppliers/BankAccountsNotVerified.vue'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    },
  },
  {
    path: '/tesoreria/gestion-de-cuentas-bancarias',
    name: 'Gestión de cuentas bancarias',
    component: () => import('../views/business/treasury/bank-accounts/UserBankAccountManagement.vue'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    },
  },
  {
    path: '/suppliers/impactaMas',
    name: 'Programa ImpactaMás',
    component: () => import('../views/admin/suppliers/ImpactaMasSupplier.vue'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    },
  },
  {
    path: '/suppliers/products',
    name: 'Catálogo de productos',
    component: () => import('../views/admin/suppliers/ProductsCatalog.vue'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    },
  },
  {
    path: '/suppliers/products/pending',
    name: 'Verificación de productos',
    component: () => import('../views/admin/suppliers/VerifyProductsCatalog.vue'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    },
  },
  {
    path: '/suppliers/certifications',
    name: 'Catálogo de certificaciones',
    component: () => import('../views/admin/suppliers/CertificationsCatalog.vue'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    },
  },
  {
    path: '/suppliers/:id',
    name: 'Instalador',
    component: () => import('../views/admin/suppliers/Supplier.vue'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/suppliers/:supplier_id/acreditaciones/:id/:update_required',
    name: 'perfilDetalleAcreditacion',
    props: true,
    component: () => import('../views/admin/suppliers/AccreditationDetail'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/treasury/trust-management/structured-lenders',
    name: 'Fidecomisos',
    component: () => import('../views/admin/treasury/trust-management/structured-lenders/StructuredLenders.vue'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/treasury/irregular-trx',
    name: 'Transacciones irregulares',
    component: () => import('../views/admin/treasury/IrregularTransactions'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/treasury/manual-trx',
    name: 'Transacciones manual ',
    component: () => import('../views/admin/treasury/manualTrx.vue'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/stp-account/duplicates',
    name: 'Cuentas STP duplicadas',
    component: () => import('../views/admin/StpAccount/StpAccountDuplicated'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/treasury/dispersions',
    name: 'Dispersiones',
    component: () => import('../views/admin/treasury-v2/index'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/treasury/transfer-to-beneficiaries',
    name: 'Ejecución de beneficiarios',
    component: () => import('../views/admin/treasury/TransferToBeneficiaries'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/recurrent-commission',
    name: 'Comisiones recurrente',
    component: () => import('../views/admin/treasury/recurrent-commission/applicant-recurrent-commission'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/treasury/withdrawals/investor/done',
    name: 'Retiros inversionistas2',
    component: () => import('../views/admin/treasury/withdrawals-investor-module'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/treasury/withdrawals/supplier/done',
    name: 'Retiros instaladores',
    component: () => import('../views/admin/treasury/withdrawals-supplier-module'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    },
    props: {
      filters: {'supplier_trx.status': 2}
    }
  },
  {
    path: '/treasury/withdrawals/rg/done',
    name: 'Retiros RG',
    component: () => import('../views/admin/treasury/withdrawals-rg-module'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/primary-market',
    name: 'Mercado Primario',
    component: () => import('../views/admin/treasury/PrimaryMarketTrading'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/secondary-market',
    name: 'Mercado secundario',
    component: () => import('../views/admin/treasury/SecondaryMarketTrading'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/treasury/loan-management',
    name: 'Gestión de Créditos',
    component: () => import('../views/admin/treasury/LoanManagementList'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/treasury/secondary-market-swaps',
    name: 'Cesiones y Permutas del MS',
    component: () => import('../views/admin/treasury/SecondaryMarketSwaps'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/treasury/loan-write-offs',
    name: 'Aplicación de Quebrantos',
    component: () => import('../views/admin/treasury/LoanWriteOffs'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/accounting/transactions',
    name: 'Transacciones',
    component: () => import('../views/admin/accounting/Transactions'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/accounting/applications',
    name: 'Aplicaciones Contables',
    component: () => import('../views/admin/accounting/Applications'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/accounting/dailyCuts',
    name: 'Cortes Diarios',
    component: () => import('../views/admin/accounting/DailyCuts'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/accounting/banksCatalog',
    name: 'Catalogo de Bancos',
    component: () => import('../views/admin/accounting/BanksCatalog'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/accounting/accountStatements',
    name: 'Carga de Estados de Cuenta',
    component: () => import('../views/admin/accounting/AccountStatements'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/accounting/trxFactor',
    name: 'Reporte por TRX con factor',
    component: () => import('../views/admin/accounting/TRXConFactor'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/accounting/paymentProcessorVariable',
    name: 'Modulo Variables de Procesador de Pagos',
    component: () => import('../views/admin/accounting/PaymentProcessorVariable'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/accounting/projectBalances',
    name: 'Balance de Proyectos',
    component: () => import('../views/admin/accounting/ProjectBalance'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/accounting/cuitfA6B3',
    name: 'Reporte CUITF A6-B3',
    component: () => import('../views/admin/accounting/ReportCuitfA6B3'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/accounting/cuitfA17',
    name: 'Reporte CUITF A17',
    component: () => import('../views/admin/accounting/ReportCuitfA17'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/accounting/pagos-dispersiones',
    name: 'Pagos vs Dispersiones',
    component: () => import('@views/admin/accounting/CobranzaPagos'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/project/v2/:id/fg_location/:fg_id',
    name: 'editarFgLocationProyecto',
    component: () => import('../views/admin/projectsv2/ProjectTechnologyEditPage'),
    props: true,
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/project/v2/:id/fg_location/:fg_id/evidencias',
    name: 'evidenciasFgLocationProyecto',
    component: () => import('../views/admin/projectsv2/ProjectTechnologyEvidencesPage'),
    props: true,
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/project/v2/:id/fg_location/:fg_id/datos-tecnicos',
    name: 'tecnicosFgLocationProyecto',
    component: () => import('../views/admin/projectsv2/ProjectTechnologyTechnicalPage'),
    props: true,
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/project/:id',
    name: 'Detalle de proyecto',
    component: () => import('../views/admin/projects/Project-Details'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    },
  },
  {
    path: '/projects/revision',
    name: 'Revisión de solicitudes',
    component: () => import('../views/admin/projects/ProjectsInRevision'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/projects/approved',
    name: 'Proyectos aprobados',
    component: () => import('../views/admin/projects/ProjectsApproved'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/projects/pendingToPublicate',
    name: 'Proyectos por publicar',
    component: () => import('../views/admin/projects/ProjectsPendingToPublicate'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/projects/funding',
    name: 'Proyectos en Fondeo',
    component: () => import('../views/admin/projects/Funding.vue'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/projects/inProcess',
    name: 'Proyectos en proceso',
    component: () => import('../views/admin/projects/ProjectsInProcess.vue'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/projects/follow-up',
    name: 'Seguimiento de proyectos',
    component: () => import('../views/admin/projects/ProjectsLeadPreApproved.vue'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/projects/feedback',
    name: 'Encuestas de Satisfacción ',
    component: () => import('../views/admin/projects/ApplicantProjectsFeedback.vue'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/projects/tools',
    name: 'Herramientas',
    component: () => import('../views/admin/projects/ProjectTools'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/projects/resale',
    name: 'Proyectos en reventa',
    component: () => import('../views/admin/projects/ProjectsResale'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/originacion/pre-solicitudes',
    name: 'Pre-revisión Originación',
    component: () => import('../views/admin/projects/process-flow/PreprojectsRevision'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/admon/referidos/:id',
    name: 'Referido',
    component: () => import('../views/admin/admon/Referal'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/admon/notificaciones',
    name: 'Notificaciones',
    component: () => import('../views/admin/admon/Notificaciones'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/admon/ajustar-saldos',
    name: 'Ajustar Saldos',
    component: () => import('../views/admin/admon/FixBalances'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/admon/estados-cuenta',
    name: 'Estados de cuenta',
    component: () => import('../views/admin/admon/Statements'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/security/accesos',
    name: 'Control de Acceso',
    component: () => import('../views/admin/security/Accesos'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/admin/Login'),
    meta: {
      rule: 'isPublic',
    }
  },
  {
    path: '/password/expiration',
    name: 'passwordExpiration',
    component: () => import('../views/admin/PasswordExpiration'),
    props: true,
    meta: {
      title: "Expiración de Contraseña",
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/admon/feedback',
    name: 'FeedBacks',
    component: () => import('../views/admin/admon/Feedback'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/catalogs',
    component: () => import("../views/admin/catalogs/Catalogs"),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/catalogs/cashing_events',
    component: () => import("../views/admin/catalogs/CashingEvents"),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/catalogs/project_events',
    name: 'Eventos de Proyecto',
    component: () => import("../views/admin/catalogs/ProjectEvents"),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/catalogs/fg_reqs',
    component: () => import("../views/admin/catalogs/FgReqs"),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/catalogs/sections',
    component: () => import("../views/admin/catalogs/Sections"),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/catalogs/fg_survey',
    component: () => import("../views/admin/catalogs/FgSurvey"),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/catalogs/compliance_requirements',
    component: () => import("../views/admin/catalogs/ComplianceRequirement"),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/catalogs/family_groups',
    component: () => import("../views/admin/catalogs/FamilyGroups"),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/catalogs/default_parameters',
    name: 'Default parameters',
    component: () => import("../views/admin/catalogs/DefaultParameters"),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/admon/templates/email',
    name: 'Plantillas de correos',
    component: () => import('../views/admin/templates/EmailTemplatesPage'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    },
  },
  {
    path: '/admon/templates/slack',
    name: 'Plantillas de Slack',
    component: () => import('../views/admin/templates/SlackTemplatesPage'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    },
  },
  {
    path: '/admon/templates/firebase',
    name: 'Plantillas de Firebase Cloud Messaging',
    component: () => import('../views/admin/templates/FCMTemplatesPage'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    },
  },
  {
    path: '/catalogs/product_groups',
    component: () => import("../views/admin/catalogs/ProductGroups"),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/error',
    name: 'notAuth',
    component: () => import("../views/admin/NotAuthPage"),
    meta: {
      rule: 'isPublic'
    }
  },
  {
    path: '*',
    component: () => import("../views/admin/NotFound"),
    meta: {
      rule: 'isBackoffice',
    }
  },
  {
    path: '/communication',
    exact: true,
    name: 'Comunicación',
    component: () => import('../views/admin/Communication'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/reports/compliance/report',
    exact: true,
    name: 'Reporte Panel de cumplimiento',
    component: () => import('../views/admin/internal-control/CompliancePanelReport'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/internal-control/xml-matches',
    exact: true,
    name: 'Control Interno - Coincidencias XML',
    component: () => import('../views/admin/internal-control/sitiaa/XmlMatches.vue'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/internal-control/sitiaa/black-list/:blackListId',
    exact: true,
    name: 'Control Interno - Lista Negra',
    component: () => import('../views/admin/internal-control/sitiaa/ShowBlackList.vue'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/juridical/projects_contracts',
    exact: true,
    name: 'Contratos de Proyectos',
    component: () => import('../views/admin/juridical/ProjectsContracts'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/juridical/contract_groups',
    exact: true,
    name: 'Grupos de Contratos',
    component: () => import('../views/admin/juridical/ContractGroups'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/juridical/contracts',
    exact: true,
    name: 'Contratos',
    component: () => import('../views/admin/juridical/Contracts'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    }
  },
  {
    path: '/proyecto/:id/fuente_ingresos/:income_source_id/:role',
    name: 'editarIncomeSourcesDeSolicitante',
    component: () => import('../views/admin/projectsv2/IncomeSourcesEditPage.vue'),
    props: true,
    meta: {
      title: 'Comprobantes de Ingreso',
      middleware: [auth],
      rule: 'isBackoffice',
      //   breadcrumb: [
      //     { title: 'Home' },
      //     { title: 'Proyecto {id}', url: '/proveedor/proyecto/{id}' },
      //     { title: 'Ingresos del Solicitante', url: '/proveedor/proyecto/{id}?nav=solicitud&tab=informacion_bancaria' },
      //     { title: 'Detalle de fuente de ingreso', active: true }
      //   ],
    }
  },
  {
    path: '/api-security',
    component: () => import('../views/admin/api-security/ApiSecurity'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice'
    }
  },
  {
    path: '/security/backend/dashboard',
    component: () => import('@views/security/backend/Dashboard.vue'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice'
    }
  },
  {
    path: '/security/navigation',
    component: () => import('../views/admin/backoffice-nav-management/BackofficeNavManagement.vue'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice'
    },
    children: [
      {
        path: '',
        name: 'Navegación - Home',
        component: () => import('@views/admin/backoffice-nav-management/MenuManager.vue'),
        meta: {
          middleware: [auth],
          rule: 'isBackoffice'
        }
      },
      {
        path: 'menu/:menuId/edit',
        name: 'Navegación - Edición menú',
        component: () => import('@views/admin/backoffice-nav-management/MenuConfig.vue'),
        meta: {
          middleware: [auth],
          rule: 'isBackoffice'
        }
      },
      {
        path: 'menu/:menuId/child/:menuItemId',
        name: 'Navegación - Menú items',
        component: () => import('@views/admin/backoffice-nav-management/MenuConfig.vue'),
        meta: {
          middleware: [auth],
          rule: 'isBackoffice'
        }
      }
    ]
  },
  {
    path: '/security/route',
    component: () => import('../views/admin/backoffice-routes/BackofficeRouteIndex'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice'
    },
    children: [
      {
        path: '',
        component: () => import('../views/admin/backoffice-routes/RouteList'),
        meta: {
          middleware: [auth],
          rule: 'isBackoffice'
        }
      },
      {
        path: 'create',
        name: 'create-route',
        component: () => import('../views/admin/backoffice-routes/NewRoute'),
        meta: {
          middleware: [auth],
          rule: 'isBackoffice'
        }
      }
    ]
  },
  {
    path: '/security/temporal-access',
    component: () => import('../views/admin/temporal-access/Index.vue'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice'
    }
  },
  {
    path: '/security/management-temporal-access',
    component: () => import('../views/admin/temporal-access-management/Index.vue'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice'
    }
  },
  {
    path: '/score/personal-profile/:id',
    component: () => import('../views/admin/Score/PersonalProfile'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice'
    }
  },
  {
    path: '/score/business-profile/:id',
    component: () => import('../views/admin/Score/BusinessProfile'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice'
    }
  },
  {
    path: '/score',
    component: () => import('../views/admin/Score/Index'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice'
    }
  },
  {
    path: '/score-busqueda',
    component: () => import('../views/admin/Score/SearchPage'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice'
    }
  },
  {
    path: '/reporte-consultas-automaticas',
    component: () => import('../views/admin/Score/CDCReport'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice'
    }
  },
  {
    path: '/verificacion-proveedores',
    component: () => import('../views/admin/Score/Suppliers/SuppliersVerification'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice'
    }
  },
  {
    path: '/reportes-regulatorios',
    name: 'Reportes regulatorios',
    component: () => import('../views/admin/reportes-regulatorios/RCards'),
    meta: {
      middleware: [auth],
      rule: 'isBackoffice',
    },
    children: [
      {
        path: 'RX',
        name: 'Reportes regulatorios RX',
        component: () => import('../views/admin/reportes-regulatorios/RX'),
        meta: {
          middleware: [auth],
          rule: 'isBackoffice',
        }
      },
      {
        path: 'consulta',
        name: 'Consulta reportes regulatorios',
        component: () => import('../views/admin/reportes-regulatorios/consulta'),
        meta: {
          middleware: [auth],
          rule: 'isBackoffice',
        }
      },
      {
        path: 'R08',
        name: 'Reportes regulatorios R08',
        component: () => import('../views/admin/reportes-regulatorios/R08'),
        meta: {
          middleware: [auth],
          rule: 'isBackoffice',
        }
      },
      {
        path: 'R27',
        name: 'Reportes regulatorios R27',
        component: () => import('../views/admin/reportes-regulatorios/R27'),
        meta: {
          middleware: [auth],
          rule: 'isBackoffice',
        }
      },

        ]
    },
    {
        path: '/treasury',
        name: 'Tesorería',
        component: () => import('../views/admin/treasury/treasury'),
        meta: {
            middleware: [auth],
            rule: 'isPublic'
        }
    },
    {
        path: '/emails/campaigns',
        name: 'Email marketing',
        component: () => import('../views/admin/emails/emails'),
        meta: {
            middleware: [auth],
            rule: 'isPublic'
        },
        children: [
            {
                path: 'audiences',
                name: 'Audiences',
                component: () => import('../views/admin/emails/Audiences/Audiences'),
                meta: {
                    middleware: [auth],
                    rule: 'isPublic'
                },
            },
            {
                path: 'audiences/new',
                component: () => import('../views/admin/emails/Audiences/Form'),
                meta: {
                    middleware: [auth],
                    rule: 'isPublic'
                },
            },
            {
                path: 'audiences/update/:id',
                component: () => import('../views/admin/emails/Audiences/Edit'),
                meta: {
                    middleware: [auth],
                    rule: 'isPublic'
                },
            },
            // {
            //     path: 'campaigns',
            //     name: 'Campaigns',
            //     component: () => import('../views/admin/emails/Campaigns/Campaigns'),
            //     meta: {
            //         middleware: [auth],
            //         rule: 'isPublic'
            //     }
            // },
            // {
            //     path: 'campaigns/new',
            //     component: () => import('../views/admin/emails/Campaigns/Form'),
            //     meta: {
            //         middleware: [auth],
            //         rule: 'isPublic'
            //     }
            // },
            // {
            //     path: 'campaigns/update/:id',
            //     component: () => import('../views/admin/emails/Campaigns/Edit'),
            //     meta: {
            //         middleware: [auth],
            //         rule: 'isPublic'
            //     }
            // },
            {
                path: 'analytics',
                name: 'Analytics',
                component: () => import('../views/admin/emails/Analytics/Analytics'),
                meta: {
                    middleware: [auth],
                    rule: 'isPublic'//isPublic
                }
            },
            // {
            //     path: 'templates',
            //     name: 'Templates',
            //     component: () => import('../views/admin/emails/Templates/Templates'),
            //     meta: {
            //         middleware: [auth],
            //         rule: 'isPublic'
            //     }
            // },
            // {
            //     path: 'templates/new',
            //     component: () => import('../views/admin/emails/Templates/Form'),
            //     meta: {
            //         middleware: [auth],
            //         rule: 'isPublic'
            //     }
            // },
            // {
            //     path: 'templates/update/:id',
            //     component: () => import('../views/admin/emails/Templates/Edit'),
            //     meta: {
            //         middleware: [auth],
            //         rule: 'isPublic'
            //     }
            // },
        ]
    },
    {
        path: '/backoffice-nav',
        component: () => import('../views/admin/backoffice-nav-management/BackofficeNavManagement.vue'),
        meta: {
            middleware: [auth],
            rule: 'isBackoffice'
        }
    },
];
